import { View } from "binder"
import { ChangePasswordViewModel } from "./changePassword-viewModel"

export class ChangePasswordView extends View<ChangePasswordViewModel>{
    GetViewUniqueId(): string {
        return "V-06B7C26B-E618-4676-9370-AA06B22C3F0C"
    }
    loadHtml(): string {
        let element = require('./changePassword.html').default;
        let style = require('./changePassword.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set oldPassword(v: string) { this._oldPassword = v; } public get oldPassword(): string { return this._oldPassword;} private _oldPassword: string;
    public set newPassword(v: string) { this._newPassword = v; } public get newPassword(): string { return this._newPassword;} private _newPassword: string;
    public set newPasswordRepetition(v: string) { this._newPasswordRepetition = v; } public get newPasswordRepetition(): string { return this._newPasswordRepetition;} private _newPasswordRepetition: string;
    
    changePassword(){
        this.dataContext.changePassword();
    }
}
